import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { URL_SERVICIOS } from "../../../environments/environment";
import { Expediente } from "../../models/expediente";
import { Rest } from "../../models/rest";
import { AuthService } from "../auth/auth.service";
import { MovimientosService } from "../movimientos/movimientos.service";

@Injectable({
  providedIn: "root",
})
export class ExpedienteService implements Rest<Expediente> {
  public _url: string = `${URL_SERVICIOS}expediente`;

  constructor(
    private http: HttpClient,
    private _movimientosService: MovimientosService,
    private _authService: AuthService
  ) {}
  get(condiciones?: any) {
    return this.http
      .get(this._url, {
        params: { condiciones: JSON.stringify([condiciones]) },
      })
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((err: any) => {
          return throwError(err);
        })
      );
  }
  buscar_expedientes(condiciones?: any) {
    return this.http
      .get(`${this._url}/busqueda_expedientes`, {
        params: { condiciones: JSON.stringify([condiciones]) },
      })
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((err: any) => {
          return throwError(err);
        })
      );
  }
  expedientes_transito(condiciones?: any) {
    return this.http
      .get(`${this._url}/expedientes_transito`, {
        params: { condiciones: JSON.stringify([condiciones]) },
      })
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((err: any) => {
          return throwError(err);
        })
      );
  }
  expedientes_vuelos(condiciones?: any) {
    return this.http
      .get(`${this._url}/expedientes_vuelos`, {
        params: { condiciones: JSON.stringify([condiciones]) },
      })
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((err: any) => {
          return throwError(err);
        })
      );
  }
  expedientes_solicitud(condiciones?: any) {
    return this.http
      .get(`${this._url}/expedientes_solicitudes`, {
        params: { condiciones: JSON.stringify([condiciones]) },
      })
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((err: any) => {
          return throwError(err);
        })
      );
  }
  expedientes_productividad(condiciones?: any) {
    return this.http
      .get(`${this._url}/expedientes_productividad`, {
        params: { condiciones: JSON.stringify([condiciones]) },
      })
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((err: any) => {
          return throwError(err);
        })
      );
  }
  getById(id: string) {
    return this.http.get(`${this._url}/byid/${id}`).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((err: any) => {
        return throwError(err);
      })
    );
  }
  filtrado(condiciones?: any) {
    return this.http
      .get(`${this._url}/filtrado`, {
        params: { condiciones: JSON.stringify([condiciones]) },
      })
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((err: any) => {
          return throwError(err);
        })
      );
  }
  insert(obj: Expediente) {
    return this.http.post(this._url, obj).pipe(
      map((res: any) => {
        const obj_movimiento_t = {
          tabla: "Expedientes",
          motivo: "Adición de registro ",
          agentes_id: this._authService.user.id,
        };
        this._movimientosService
          .insert(obj_movimiento_t)
          .subscribe((res: any) => {});

        return res;
      }),
      catchError((err: any) => {
        return throwError(err);
      })
    );
  }
  update(id: string, obj: Expediente) {
    return this.http.put(`${this._url}/${id}`, obj).pipe(
      map((res: any) => {
        const obj_movimiento_t = {
          tabla: "Expedientes",
          motivo: "Edición de registro ",
          agentes_id: this._authService.user.id,
        };
        this._movimientosService
          .insert(obj_movimiento_t)
          .subscribe((res: any) => {});
        return res;
      }),
      catchError((err: any) => {
        return throwError(err);
      })
    );
  }
  delete(id: string) {
    return this.http.delete(`${this._url}/${id}`).pipe(
      map((res: any) => {
        const obj_movimiento_t = {
          tabla: "Expedientes",
          motivo: "Borrado de registro ",
          agentes_id: this._authService.user.id,
        };
        this._movimientosService
          .insert(obj_movimiento_t)
          .subscribe((res: any) => {});
        return res;
      }),
      catchError((err: any) => {
        return throwError(err);
      })
    );
  }
  removeexpediente(id: any, clienteprincipal: any) {
    return this.http.get(`${this._url}/update/${id}/${clienteprincipal}`).pipe(
      map((res: any) => {
        const obj_movimiento_t = {
          tabla: "Expedientes",
          motivo: "Edición de registro ",
          agentes_id: this._authService.user.id,
        };
        this._movimientosService
          .insert(obj_movimiento_t)
          .subscribe((res: any) => {});
        return res;
      }),
      catchError((err: any) => {
        return throwError(err);
      })
    );
  }
}
